
var request = require('../utils/request.js');

var common = {
  gettime:function(){
    return new Promise((resolve,reject) => {
      request({
          url:'/api/common/timestamp',
          method:'get',
      }).then(res=>{
          if(!res.error) {
              resolve(res);
          }else {
              reject();
          }
      })
    })
  },
  sendsms:function({phone,type='login'}) {
    return new Promise((resolve, reject)=>{
      request({
        url:'/api/common/sendsms',
        method:'post',
        data:{phone,type}
      }).then(res=>{
        if(!res.error) {
          resolve();
        }else {
          reject();
        }
      });
    });
  },
  preorder:function(opt) {
    return new Promise((resolve, reject)=>{
      request({
        url: '/api/common/preorder',
        method: 'post',
        data: opt
      }).then(res => {
        if (!res.error) {
          resolve();
        } else {
          reject();
        }
      })
    });
  }
};

module.exports = common;


// WEBPACK FOOTER //
// ./src/actions/common.js